import publicAxios from "../../utils/publicAxios";
import { getSend2FACodeURL } from "../../utils/constants/apiEndPoints";
import { login } from "../../locales/en";
import { showToast } from "../../utils/utils";
import { showToastType } from "../../utils/constants/appConstants";

export default function useSentTwoFaQrcode({
  values,
  errors,
  setErrors,
  setValues,
  setLoading,
  setTwoFAVerificationButton,
  setSuccess,
  setQrCodeVisible
}) {
  const handleSentTwoFaQrcode = async (event) => {
    event.preventDefault();

    let isValid = true;

    const newErrors = { ...errors };

    if (values.email.trim() === "") {
      newErrors.email = login?.errorMSG.enterEmail;
      isValid = false;
    }

    if (values.password.trim() === "") {
      newErrors.password = [login?.errorMSG.enterPassword];
      isValid = false;
    }

    setErrors(newErrors);
    if (isValid) {
      setValues((prev) => ({ ...prev, error: "" }));

      const userData = {
        email: values.email,
        password: values.password
      };

      try {
        setLoading((prev) => ({ ...prev, reSendTwoFaBtn: true }));
        const response = await publicAxios.post(getSend2FACodeURL, userData);
        if (response.status === 200) {
          setValues((prev) => ({ ...prev, twoFARequired: true }));
          setTwoFAVerificationButton(true);
          setErrors((prev) => ({
            ...prev,
            twoFactorCode: "",
            invalidMessage: "",
            invalidOTPMessage: "",
            errorMessage: ""
          }));
          const message = response.data.message;

          setSuccess((prev) => ({ ...prev, twoFactorResent: message }));
          setQrCodeVisible(false);
        }
      } catch {
        showToast(login?.errorMSG.somethingWrong, showToastType.error);
      } finally {
        setLoading((prev) => ({ ...prev, reSendTwoFaBtn: false }));
      }
    }
  };

  return handleSentTwoFaQrcode;
}
